import { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { saveUserCoevaluationHomework } from 'store/lesson-actions';
import { useTranslation } from 'react-i18next';

import Button from '@mui/material/Button';

import Coevaluation from 'components/UI/Coevaluation/Coevaluation';
import ModalViewPDF from 'components/UI/ModalViewPDF/ModalViewPDF';

import classes from './CoevaluationUserActivity.module.css';

const CoevaluationsUserActivity = props => {
  const { t } = useTranslation(['lesson']);
  const dataAcademy = useSelector(state => state.academyInfo);
  const [coevaluationActivityData, setCoevaluationActivityData] =
    useState([]);
  const [openActivity, setOpenActivity] = useState(false);
  const [coevaluationComment, setCoevaluationComment] = useState('');

  const openActivityHandler = () => {
    setOpenActivity(true);
  };

  const closeActivityHandler = () => {
    setOpenActivity(false);
  };

  const coevaluationCommentHandler = comment => {
    setCoevaluationComment(comment);
  };

  const coevaluationActivityHandler = (orderItem, valueItem) => {
    let addNewData = {
      orderItem,
      valueItem
    };
    let data = coevaluationActivityData;
    data = data.filter(item => item.orderItem !== orderItem);
    data.push(addNewData);
    setCoevaluationActivityData(data);
  };

  const sendCoevaluationHandler = () => {
    let coevalTotal = 0;
    coevaluationActivityData.map(item => {
      coevalTotal += item.valueItem;
    });
    (async () => {
      const coevalActivity = await saveUserCoevaluationHomework(
        props.idUserActivity,
        props.idCourse,
        props.idLesson,
        coevalTotal,
        dataAcademy.data.shortName,
        coevaluationComment
      );
      if (coevalActivity) {
        props.closeCoevalUser();
        props.activitiesCoevaluate(props.idUserActivity);
        props.changeCoevaluationStatus();
      }
    })();
  };

  return (
    <>
      <p className={classes.title}>{props.title}</p>
      <p className={classes.instructions}>
        {t('peer_evaluate_instructions')}
      </p>
      <Button
        onClick={openActivityHandler}
        className={classes.nextBtn}
      >
        {t('see_activity')}
      </Button>
      <Button
        onClick={props.closeCoevalUser}
        className={classes.nextBtn}
      >
        {t('back')}
      </Button>
      <Coevaluation
        coevaluationItems={props.coevaluationsItems}
        coevaluationActivity={coevaluationActivityHandler}
        coevaluationCommentHandler={coevaluationCommentHandler}
      />
      <Button
        disabled={
          !(
            coevaluationActivityData.length ===
            props.coevaluationsItems.length
          )
        }
        onClick={sendCoevaluationHandler}
        className={classes.sendCoevaluation}
      >
        {t('send_peer_review')}
      </Button>
      <ModalViewPDF
        urlCloudFront={props.pdf}
        openModal={openActivity}
        onCloseModal={closeActivityHandler}
        urlViewPDF={props.pdf}
        titlePDF={props.title}
      />
    </>
  );
};

CoevaluationsUserActivity.propTypes = {
  // eslint-disable-next-line react/require-default-props
  pdf: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  title: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  closeCoevalUser: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  coevaluationsItems: PropTypes.array,
  // eslint-disable-next-line react/require-default-props
  idCourse: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  idLesson: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  idUserActivity: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  activitiesCoevaluate: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  changeCoevaluationStatus: PropTypes.func
};

export default CoevaluationsUserActivity;
